import { useState } from 'react';
import { useQuery } from 'react-query';
import DoughnutChart from 'components/pages/professor/statistics/DoughnutChart';
import BarChart from 'components/pages/common/BarChart';
import TableForm from 'components/common/lists/TableForm';
import { ChartInfo } from 'constants/chart/common/chartInfo';
import { TTableColumn } from 'types/components/table';
import { TScoreByChart } from 'types/chart';
import { TAxiosResponse } from 'types/apis/api';
import {
  TStatisticsByRoundResponse,
  TFailureLists,
} from 'types/apis/professor';
import { getStatisticsByRound } from 'apis/professor';

const tableColumns: TTableColumn[] = [
  {
    name: 'rank',
    label: '순위',
    width: '102px',
  },
  { name: 'chartTypeName', label: '차트 종류', width: '200px' },
  {
    name: 'allStudentCount',
    label: '전체 수강 인원',
    width: '200px',
  },
  {
    name: 'failureStudentCount',
    label: '평균 미달 인원',
    width: '200px',
  },
  {
    name: 'averageScore',
    label: '평균 점수',
    width: '118px',
  },
  { name: 'failureAverageScore', label: '평균 미달 점수', width: '200px' },
];

const chartScoreDataDefaultValues = ChartInfo.map((chart) => ({
  chartName: chart.name,
  score: null,
}));

type TProps = {
  courseInfoId: number | undefined;
  chartRound: number | undefined;
};

const StatisticsByRound = ({ courseInfoId, chartRound }: TProps) => {
  const [totalCount, setTotalCount] = useState<number>(0);
  const [scoreRange, setScoreRange] = useState<number[]>([0, 0, 0, 0, 0]);
  const [scorePercent, setScorePercent] = useState<number[]>([0, 0, 0, 0, 0]);
  const [chartScore, setChartScore] = useState<TScoreByChart[]>(
    chartScoreDataDefaultValues
  );

  const { data: statisticsByRoundData } = useQuery(
    ['getStatisticsByRound', courseInfoId, chartRound],
    () => {
      if (!courseInfoId || !chartRound) return;
      return getStatisticsByRound({
        courseInfoId,
        chartRound,
      });
    },
    {
      enabled: !!courseInfoId && !!chartRound,
      onSuccess: ({ data }: TAxiosResponse<TStatisticsByRoundResponse>) => {
        if (!data) return;
        // 학생 종합 평가 점수
        setTotalCount(data.allStudentCount || 0);
        if (data.studentCountByScoreRange) {
          setScoreRange(
            Object.entries(data.studentCountByScoreRange)
              .filter(([key]) => key.includes('Count'))
              .map(([, value]) => value)
          );
          setScorePercent(
            Object.entries(data.studentCountByScoreRange)
              .filter(([key]) => key.includes('Percent'))
              .map(([, value]) => value)
          );
        }
        // 차트별 평균 점수
        setChartScore(
          ChartInfo.map((chart) => {
            const score = data.allChartAverageScore.find(
              (item) => item.chartType === chart.type
            )?.averageScore;
            return {
              chartName: chart.name,
              score: score !== null && score !== undefined ? score : null,
            };
          })
        );
      },
    }
  );

  // 평균 미달 차트 순위
  const tableData: TFailureLists[] =
    statisticsByRoundData?.data?.failureLists || [];

  return (
    <>
      {/* 학생 종합 평가 점수 */}
      <DoughnutChart
        totalCount={totalCount}
        data={scoreRange}
        percent={scorePercent}
      />

      {/* 차트별 평균 점수 */}
      <BarChart type="professor" data={chartScore} />

      {/* 평균 미달 차트 순위 */}
      <div className="mt40">
        <h2 className="mb24 main_title">평균 미달 차트 순위</h2>
        <TableForm
          data={tableData}
          columns={tableColumns}
          isStatistics={true}
          emptyMessage="등록된 차트가 없습니다."
        />
      </div>
    </>
  );
};
export default StatisticsByRound;
